<template>
  <div class="addBrand">
    <div class="shade">
      <div class="hintCont">
        <div class="title">
          <span>添加品牌</span>
          <img src="@/assets/images/close.png" alt @click="closePage" />
        </div>
        <el-row :gutter="30">
          <el-col :span="8">
            <div class="grid-content bg-purple lft">
              <span>品牌名称</span>
            </div>
          </el-col>
          <el-col :span="14">
            <div class="grid-content bg-purple-light">
              <el-input
                v-model="name"
                placeholder="请输入内容"
                size="small"
              ></el-input>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="30">
          <el-col :span="8">
            <div class="grid-content bg-purple lft">
              <span>LOGO</span>
            </div>
          </el-col>
          <el-col :span="14">
            <div class="grid-content bg-purple-light">
              <el-upload
                ref="upload"
                class="avatar-uploader"
                action="http://www.58zltc.com/api/Upload/uploads/"
                :show-file-list="false"
                accept="image/*"
                :on-success="handleAvatarSuccess"
                :data="imgdata"
                :on-change="changefile"
                :file-list="fileList"
                :auto-upload="false"
              >
              <!-- 可能出现的待修改
              上传图片时切换了图片将数据记载进来
              1上传的时候只选取最后一次，
              2修改上传方法，自动上传既可以，并限制上传数量，或者使用缩略图的方法， -->
                <el-button size="small" type="primary">点击上传</el-button>
                <div
                  class="img"
                  v-loading="loading"
                  element-loading-text="上传中"
                   v-if="imageUrl"
                >
                  <img :src="imageUrl" class="avatar" />
                </div>
              </el-upload>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="30">
          <el-col :span="8">
            <div class="grid-content bg-purple lft">
              <span>排序</span>
            </div>
          </el-col>
          <el-col :span="14">
            <div class="grid-content bg-purple-light">
              <el-input
                v-model="sort"
                placeholder="请输入内容"
                size="small"
              ></el-input>
            </div>
          </el-col>
        </el-row>
        <div class="Operation">
          <el-button
            type="primary"
            size="small"
            style="width:100%"
            @click="upLogo"
            >确认</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { addBrand } from "../../api/mall.js";
export default {
  computed: {
    ...mapGetters(["token","app_id","merch_id"])
  },
  data() {
    return {
      fileList:[],
      imageUrl: "",
      name: "",
      sort: "",
      values: true,
      changeClass: "1",
      idx: 1,
      nowIDx: 0,
      value: "",
      input: "",
      input3: "",
      radio: "",
      loading: false,
      imgdata: {},
      logoUrl: ""
    };
  },
  methods: {
    closePage() {
      this.$emit("close", false);
    },
    handleDelete(index, row) {
      console.log(index, row);
    },
    // 文件选取的时候调用
    changefile(file, fileList) {
      this.fileList = [];
      this.fileList.push(fileList.pop())
      console.log(file, fileList);
      this.imageUrl = URL.createObjectURL(file.raw);
      this.imgdata = {
        token: this.token,
        image: file.raw,
        type: "1",
        file_group: "1"
      };
      console.log(fileList)
    },
    // 上传成功
    handleAvatarSuccess(res, file) {
      console.log(res, file);
      this.imageUrl = URL.createObjectURL(file.raw);
      this.logoUrl = res.data.id;
      // console.log(this.logoUrl)
      this.loading = false;
      this.upData();
    },

    upLogo() {
      // 上传品牌
      if (this.imageUrl == "" || this.name == "") {
        this.$message("内容不许为空");
      } else {
        this.$refs.upload.submit();
      }
    },
    upData() {
      let data = {
        token: this.token,
        app_id: this.app_id,
        logo: this.logoUrl,
        name: this.name,
        sort: this.sort,
        merch_id: this.merch_id
      };
      addBrand(data).then(res => {
        console.log(res);
        this.$emit("close", false);
        this.name = "";
        this.sort = "";
        this.imageUrl = "";
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.addBrand {
  height: 100%;
  position: absolute;
  z-index: 2;
  .shade {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.3);
    .hintCont {
      position: absolute;
      top: 18%;
      width: 400px;
      left: 50%;
      margin-left: -200px;
      background: #fff;
      min-height: 410px;
      .title {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding: 10px 20px;
        margin-bottom: 20px;
      }
      .el-row {
        margin-bottom: 20px;
      }
      .grid-content {
        min-height: 36px;
        line-height: 36px;
        .img {
          width: 80px;
          height: 80px;
          margin-top: 15px;
          // background: #409eff;
          img {
            width: 100%;
          }
        }
      }
      .lft {
        text-align: right;
      }
      .Operation {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        min-height: 36px;
        margin: 30px 0 0 0;
        padding: 0 20px;
      }
    }
  }
}
</style>
